import moment from "moment";
import { FARUserHistoryIcon } from "../../assets/images";
import { FixedAssetUsersHistoryData } from "../../redux/fixedAsset/fixedAssetRegisterTypes";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";

type AppProps = {
  data: FixedAssetUsersHistoryData[] | [];
};
const FixedAssetUsersHistory = ({ data }: AppProps) => {
  return (
    <div
      style={{
        border: "1px dashed rgba(191, 203, 225, 0.6)",
        borderTop: "none",
      }}
    >
      {data?.length > 0 ? (
        data?.map((user: FixedAssetUsersHistoryData, index: number) => {
          return (
            <div
              className="d-flex justify-content-left"
              style={{
                height: "100px",
                marginLeft: "20px",
                paddingTop: "20px",
                marginBottom: index === data?.length - 1 ? "30px" : "",
              }}
            >
              <div style={{ height: "100%" }}>
                <img src={FARUserHistoryIcon} alt="history" />
                <div
                  style={{
                    width: "2px",
                    backgroundColor:
                      index === data?.length - 1 ? "" : "#8D93B3",
                    margin: "auto",
                    height: index === data?.length - 1 ? "" : "70%",
                  }}
                ></div>
              </div>
              <div
                className="d-flex justify-content-left"
                style={{ margin: "1px 0px 0px 15px" }}
              >
                <div>
                  <CustomizedAvatar
                    image={user?.profile_pic?.file_url}
                    name={`${user?.first_name} ${
                      user?.last_name ? user?.last_name : ""
                    }`}
                    style={{ width: "42px", fontSize: "15px" }}
                  />
                </div>
                <div className="d-block ml-2">
                  <span style={{ fontWeight: "500", display: "block" }}>
                    {`${user?.first_name} ${
                      user?.last_name ? user?.last_name : ""
                    } ${user?.job_title ? `(${user?.job_title})` : ""}`}
                  </span>
                  <span className="d-block" style={{ color: "#262A44 " }}>
                    {user?.far_start_date
                      ? moment(user?.far_start_date).format("DD-MM-YYYY")
                      : "NA"}{" "}
                    to{" "}
                    {user?.far_end_date
                      ? moment(user?.far_end_date).format("DD-MM-YYYY")
                      : "Present"}
                  </span>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="p-5 d-flex justify-content-center align-items-center">
          No Asset History Found!
        </div>
      )}
    </div>
  );
};

export default FixedAssetUsersHistory;
